import {
  ImageScaleView,
  LinearAddFilter,
  View,
  ViewOpts,
} from '@play-co/timestep-core/ui';
import gsap from 'gsap';
import { streakBattleRoyaleTheme } from '../streakbattleroyale.theme';

export default class StreakGlare extends View {
  private tween: gsap.core.Tween;

  constructor(opts: ViewOpts) {
    super({ superview: opts.superview });

    const glare = new ImageScaleView({
      ...opts,
      superview: this,
      image: streakBattleRoyaleTheme().getAsset('glare'),
      width: 457,
      height: 391,
      centerOnOrigin: true,
      filter: new LinearAddFilter('rgba(255, 255, 255, 1)'),
    });

    this.tween = gsap.to(glare.style, {
      duration: 10,
      r: Math.PI * 2,
      repeat: -1,
      ease: 'none',
    });
  }

  public stopAnimation() {
    this.tween.kill();
  }
}
